<script>
import UserResource from '@/resources/user'
import messages from '@/mixins/messages'
import { loadStripe } from '@stripe/stripe-js'
import { client } from '@/resources'
import CompanyResource from '../resources/company'

export default {
    mixins: [messages],
    data() {
        return {
            cardEl: null,
            stripeAPI: null,
            paymentDetails: false,
            loading: true,
            entry: false,
            updatingPaymentMethod: false
        }
    },
    props: {
        companyResource: {
            type: CompanyResource,
            required: true,
        },
        showSubmit: {
            type: Boolean,
            default: true
        },
        buttonSize: {
            type: String,
            default: 'md'
        },
        buttonText: {
            type: String,
            default: 'Add Payment Method'
        },
        allowUpdate: {
            type: Boolean,
            default: true
        },
        allowCancel: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        entry() {
            if(this.entry) {
                // Mount, but wait 10ms -- this helps with hot reloading issues
                setTimeout(() => this.cardEl.mount(this.$refs.stripeElementTarget), 10)
            }
        },
        paymentDetails() {
            this.$emit('success', this.paymentDetails)
        }
    },
    methods: {
        async submit() {
            this.updatingPaymentMethod = true
            let event = await this.stripeAPI.createToken(this.cardEl)
            if (event.error) {
                this.addError(event.error.message)
                this.$emit('error', event.error)
                this.updatingPaymentMethod = false
            } else if(event.token) {
                this.clearMessages()
                this.$emit('token', event.token)
                try {
                    this.paymentDetails = await this.companyResource.addDefaultPaymentMethod(event.token.id)
                    this.entry = false
                    return true
                } catch(e) {
                    this.addError(this.parseAPIErrorsOrRethrow(e))
                } finally {
                    this.updatingPaymentMethod = false
                }
            }

            return false
        },
    },
    async mounted() {
        let apiMeta = await this.$store.dispatch('getAPIMeta')
        let [stripe, payment] = await Promise.all([
            loadStripe(apiMeta['STRIPE_PUBLISHABLE_KEY']),
            this.companyResource.getDefaultPaymentMethod()]
        )

        this.stripeAPI = stripe
        this.paymentDetails = payment

        if(!this.paymentDetails) {
            this.entry = true
        }

        this.loading = false
        let elements = stripe.elements()

        let style = {
            base: {
                color: '#303238',
                padding: '0.375rem 0.75rem',
                backgroundColor: '#fff',
                border: '1px solid #ced4da',
                fontSize: '20px',
                fontSmoothing: 'antialiased',
                '::placeholder': {
                    color: '#CFD7DF',
                },
            },
            invalid: {
                color: '#e5424d',
                ':focus': {
                    color: '#303238',
                },
            },
        }

        this.cardEl = elements.create('card', { style })
        this.cardEl.on('change', this.clearMessages.bind(this))
    },
}
</script>

<template>
    <div>
        <div v-if="!loading">
            <!--<b-card no-body>
                <b-tabs pills card vertical>
                    <b-tab title="Credit Card" active>
                        <b-card-text>-->
                            <form @submit.prevent="submit" v-if="entry">
                                <b-form-group class="mt-3">
                                    <!-- Stripe Elements field will appear here -->
                                    <div ref="stripeElementTarget"></div>
                                </b-form-group>
                                <messages :to="messages" />
                                <b-button type="submit" variant="primary" v-if="showSubmit" :size="buttonSize" class="mt-3" :disabled="updatingPaymentMethod">{{ buttonText }}</b-button>
                                <b-button variant="link" @click="entry = false" :size="buttonSize" class="mt-3" v-if="paymentDetails && allowCancel && showSubmit">Cancel</b-button>
                            </form>

                            <div v-else>
                                <p><b-icon icon="credit-card" /> {{ paymentDetails.brand.toUpperCase() }} **** **** **** {{ paymentDetails.last4 }}</p>
                                <p>{{ paymentDetails.exp_month }} / {{ paymentDetails.exp_year }} <span v-if="paymentDetails.billing_postal_code">— Postal Code: {{ paymentDetails.billing_postal_code }}</span></p>
                                <p v-if="allowUpdate"><a href="javascript:{}" @click="entry = true">Update Payment Method</a></p>
                            </div>
                            <slot />
                        <!--</b-card-text>
                    </b-tab>
                    <b-tab title="Bank Account" disabled />
                    <b-tab title="PayPal" disabled />
                </b-tabs>
            </b-card>-->


        </div>

        <div v-else>
            Loading...
        </div>
    </div>
</template>
